var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    attrs: {
      "elevation": "0"
    }
  }, [_c('div', [_c('div', {
    staticClass: "tit-wrap mb-10px mb-md-20px"
  }, [_c('h3', {
    staticClass: "tit tit--xs"
  }, [_vm._v("회원정보(필수)")])]), _c('div', {
    staticClass: "table-style table-style--default"
  }, [_c('div', {
    staticClass: "table-style__row"
  }, [_c('div', {
    staticClass: "table-style__th"
  }, [_vm._v("아이디")]), _c('div', {
    staticClass: "table-style__td"
  }, [_c('v-row', {
    staticClass: "row--x-small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "my-6px"
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "placeholder": "아이디",
      "outlined": "",
      "hide-details": "",
      "clearable": ""
    },
    on: {
      "input": function input($event) {
        return _vm.exists();
      }
    },
    model: {
      value: _vm.member.username,
      callback: function callback($$v) {
        _vm.$set(_vm.member, "username", $$v);
      },
      expression: "member.username"
    }
  }, 'v-text-field', _vm.$attrs, false)), _vm.errors ? _c('div', {
    staticStyle: {
      "color": "red",
      "font-size": "14px"
    }
  }, [_vm._v("*" + _vm._s(_vm.errors))]) : _vm._e(), _c('p', {
    staticClass: "font-size-14 primary--text pt-6px"
  }, [_vm._v("* 4~12 영문·숫자 조합, 가입 후 아이디 변경은 불가능함을 알려드립니다.")])], 1)])], 1)], 1)]), _c('div', {
    staticClass: "table-style__row"
  }, [_c('div', {
    staticClass: "table-style__th"
  }, [_vm._v("비밀번호")]), _c('div', {
    staticClass: "table-style__td"
  }, [_c('v-row', {
    staticClass: "row--x-small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-password-field', _vm._b({
    attrs: {
      "placeholder": "비밀번호",
      "outlined": "",
      "hide-details": "",
      "autocomplete": "new-password"
    },
    model: {
      value: _vm.member.password,
      callback: function callback($$v) {
        _vm.$set(_vm.member, "password", $$v);
      },
      expression: "member.password"
    }
  }, 'v-password-field', _vm.$attrs, false))], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-password-field', _vm._b({
    attrs: {
      "placeholder": "비밀번호확인",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.member.password2,
      callback: function callback($$v) {
        _vm.$set(_vm.member, "password2", $$v);
      },
      expression: "member.password2"
    }
  }, 'v-password-field', _vm.$attrs, false)), _c('div', {
    staticStyle: {
      "color": "red",
      "font-size": "14px"
    }
  }, [_vm._v(_vm._s(_vm.passwordErrors))]), _c('p', {
    staticClass: "font-size-14 primary--text pt-6px"
  }, [_vm._v("* 영문·숫자·특수문자 조합으로 10자리 이상 20자리 이하입니다.")])], 1)], 1)], 1)]), _c('div', {
    staticClass: "table-style__row"
  }, [_c('div', {
    staticClass: "table-style__th"
  }, [_vm._v("이름")]), _c('div', {
    staticClass: "table-style__td"
  }, [_c('v-row', {
    staticClass: "row--x-small"
  }, [_c('v-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "placeholder": "이름",
      "outlined": "",
      "hide-details": "",
      "readonly": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.kcpCert.open();
      }
    },
    model: {
      value: _vm.member.name,
      callback: function callback($$v) {
        _vm.$set(_vm.member, "name", $$v);
      },
      expression: "member.name"
    }
  }, 'v-text-field', _vm.$attrs, false))], 1), _c('v-col', {
    attrs: {
      "cols": "auto",
      "md": "6"
    }
  }, [_c('v-btn', {
    staticClass: "v-btn--input",
    attrs: {
      "large": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.kcpCert.open();
      }
    }
  }, [_vm._v("본인인증")])], 1)], 1)], 1)]), _c('div', {
    staticClass: "table-style__row"
  }, [_c('div', {
    staticClass: "table-style__th"
  }, [_vm._v("연락처")]), _c('div', {
    staticClass: "table-style__td"
  }, [_c('v-row', {
    staticClass: "row--x-small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    staticClass: "row--small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', [_c('v-text-field', _vm._b({
    attrs: {
      "placeholder": "연락처",
      "outlined": "",
      "hide-details": "",
      "readonly": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.kcpCert.open();
      }
    },
    model: {
      value: _vm.member.phone1,
      callback: function callback($$v) {
        _vm.$set(_vm.member, "phone1", $$v);
      },
      expression: "member.phone1"
    }
  }, 'v-text-field', _vm.$attrs, false))], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("-")]), _c('v-col', [_c('v-text-field', _vm._b({
    attrs: {
      "maxlength": "4",
      "outlined": "",
      "hide-details": "",
      "readonly": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.kcpCert.open();
      }
    },
    model: {
      value: _vm.member.phone2,
      callback: function callback($$v) {
        _vm.$set(_vm.member, "phone2", $$v);
      },
      expression: "member.phone2"
    }
  }, 'v-text-field', _vm.$attrs, false))], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("-")]), _c('v-col', [_c('v-text-field', _vm._b({
    attrs: {
      "maxlength": "4",
      "outlined": "",
      "hide-details": "",
      "readonly": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.kcpCert.open();
      }
    },
    model: {
      value: _vm.member.phone3,
      callback: function callback($$v) {
        _vm.$set(_vm.member, "phone3", $$v);
      },
      expression: "member.phone3"
    }
  }, 'v-text-field', _vm.$attrs, false))], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "sms 수신동의",
      "hide-details": ""
    },
    model: {
      value: _vm.member.smsEnabled,
      callback: function callback($$v) {
        _vm.$set(_vm.member, "smsEnabled", $$v);
      },
      expression: "member.smsEnabled"
    }
  })], 1)], 1)], 1)]), _c('div', {
    staticClass: "table-style__row"
  }, [_c('div', {
    staticClass: "table-style__th"
  }, [_vm._v("이메일")]), _c('div', {
    staticClass: "table-style__td"
  }, [_c('v-row', {
    staticClass: "row--x-small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    staticClass: "row--small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', [_c('v-text-field', _vm._b({
    attrs: {
      "placeholder": "이메일",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.member.email1,
      callback: function callback($$v) {
        _vm.$set(_vm.member, "email1", $$v);
      },
      expression: "member.email1"
    }
  }, 'v-text-field', _vm.$attrs, false))], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("@")]), _c('v-col', [_c('v-text-field', _vm._b({
    attrs: {
      "hide-details": ""
    },
    model: {
      value: _vm.member.email2,
      callback: function callback($$v) {
        _vm.$set(_vm.member, "email2", $$v);
      },
      expression: "member.email2"
    }
  }, 'v-text-field', _vm.$attrs, false))], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("-")]), _c('v-col', [_c('v-select', _vm._b({
    attrs: {
      "persistent-hint": "",
      "items": _vm.prependEmails,
      "item-text": "text",
      "item-value": "value",
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "input": function input($event) {
        _vm.member.email2 = _vm.member.email3;
      }
    },
    model: {
      value: _vm.member.email3,
      callback: function callback($$v) {
        _vm.$set(_vm.member, "email3", $$v);
      },
      expression: "member.email3"
    }
  }, 'v-select', _vm.$attrs, false))], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "email 수신동의",
      "hide-details": ""
    },
    model: {
      value: _vm.member.emailEnabled,
      callback: function callback($$v) {
        _vm.$set(_vm.member, "emailEnabled", $$v);
      },
      expression: "member.emailEnabled"
    }
  })], 1)], 1)], 1)]), _c('div', {
    staticClass: "table-style__row"
  }, [_c('div', {
    staticClass: "table-style__th"
  }, [_vm._v("주소")]), _c('div', {
    staticClass: "table-style__td"
  }, [_c('v-row', {
    staticClass: "row--x-small"
  }, [_c('v-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "placeholder": "우편번호",
      "outlined": "",
      "hide-details": "",
      "readonly": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.daumPostcode.open();
      }
    },
    model: {
      value: _vm.member.postcode,
      callback: function callback($$v) {
        _vm.$set(_vm.member, "postcode", $$v);
      },
      expression: "member.postcode"
    }
  }, 'v-text-field', _vm.$attrs, false))], 1), _c('v-col', {
    attrs: {
      "cols": "auto",
      "md": "6"
    }
  }, [_c('v-btn', {
    staticClass: "v-btn--input",
    attrs: {
      "large": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.daumPostcode.open();
      }
    }
  }, [_vm._v("주소검색")])], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "placeholder": "기본주소",
      "outlined": "",
      "hide-details": "",
      "readonly": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.daumPostcode.open();
      }
    },
    model: {
      value: _vm.member.address1,
      callback: function callback($$v) {
        _vm.$set(_vm.member, "address1", $$v);
      },
      expression: "member.address1"
    }
  }, 'v-text-field', _vm.$attrs, false))], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "placeholder": "상세주소",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.member.address2,
      callback: function callback($$v) {
        _vm.$set(_vm.member, "address2", $$v);
      },
      expression: "member.address2"
    }
  }, 'v-text-field', _vm.$attrs, false))], 1)], 1)], 1)])]), _c('div', {
    staticClass: "mt-20px mt-md-40px text-center"
  }, [_c('v-btn', {
    attrs: {
      "width": "120",
      "x-large": "",
      "color": "primary"
    },
    on: {
      "click": _vm.join
    }
  }, [_vm._v("회원가입")])], 1)]), _c('kcp-cert', {
    ref: "kcpCert",
    on: {
      "input": _vm.certify
    }
  }), _c('daum-postcode', {
    ref: "daumPostcode",
    on: {
      "input": function input(_ref) {
        var postcode = _ref.postcode,
            address = _ref.address;
        _vm.member.postcode = postcode;
        _vm.member.address1 = address;
      }
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }